import React, { useState } from "react";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  // State to track the active section
  const [activeSection, setActiveSection] = useState("cat1"); // 'cat1' is for Mission, 'cat2' is for Vision

  return (
    <div className="space space-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-10">
            <div className="title-area text-center">
              <span className="sub-title6 justify-content-center">
                <span className="shape left">
                  <span className="dots"></span>
                </span>
                mission & vision
                <span className="shape right">
                  <span className="dots"></span>
                </span>
              </span>
              <h2 className="sec-title">Our Mission & Vision</h2>
            </div>
          </div>
        </div>

        <div className="tab-menu2 filter-menu-active">
          {/* Button to switch between Mission and Vision */}
          <button
            data-filter=".cat1"
            className={activeSection === "cat1" ? "active" : ""}
            onClick={() => setActiveSection("cat1")}
            type="button"
          >
            Mission
          </button>
          <button
            data-filter=".cat2"
            className={activeSection === "cat2" ? "active" : ""}
            onClick={() => setActiveSection("cat2")}
            type="button"
          >
            Vision
          </button>
        </div>

        <div className="mission-box-wrap mt-50">
          {/* Mission Section */}
          {activeSection === "cat1" && (
            <div className="filter-item cat1">
              <div className="mission-grid">
                <div
                  className="mission-img rounded-20"
                  data-overlay="title"
                  data-opacity="2"
                >
                  <img src="/assets/image/clean/10.jpg" alt="mission img" />
                  <Link
                    to="https://www.youtube.com/watch?v=_sI_Ps7JSEk"
                    className="play-btn style3 popup-video"
                  >
                    <i className="fas fa-play"></i>
                  </Link>
                </div>

                <div className="mission-content">
                  <h3 className="mission-title">
                    Providing Unmatched Pest Control & Cleaning Solutions
                  </h3>
                  <p className="mission-text">
                    At Al Jurf Pest Control LLC, our mission is to provide
                    effective, reliable, and environmentally safe pest control
                    and cleaning services to our clients across Dubai. We are
                    committed to delivering exceptional results with the highest
                    standards of professionalism, ensuring the health, safety,
                    and comfort of your home or business.
                  </p>
                  <div className="checklist style5 text-dark">
                    <ul className="d-flex flex-column">
                      <li className="text-dark">
                        Delivering Safe and Effective Pest Control with
                        Integrity
                      </li>
                      <li className="text-dark">
                        Using Advanced Technology to Protect Homes and
                        Businesses
                      </li>
                      <li className="text-dark">
                        Promoting Healthier Environments Through Sustainable
                        Practices
                      </li>
                      <li className="text-dark">
                        Building Long-Term Trust Through Quality and Reliability
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Vision Section */}
          {activeSection === "cat2" && (
            <div className="filter-item cat2">
              <div className="mission-grid">
                <div
                  className="mission-img rounded-20"
                  data-overlay="title"
                  data-opacity="2"
                >
                  <img src="/assets/image/clean/9.jpg" alt="vision img" />
                  <Link
                    to="https://www.youtube.com/watch?v=_sI_Ps7JSEk"
                    className="play-btn style3 popup-video"
                  >
                    <i className="fas fa-play"></i>
                  </Link>
                </div>

                <div className="mission-content">
                  <h3 className="mission-title">
                    Leading the Way in Pest Control & Cleaning Services in
                    Dubai!
                  </h3>
                  <p className="mission-text">
                    Our vision at Al Jurf Pest Control LLC is to provide safe,
                    efficient, and eco-friendly pest control and cleaning
                    solutions for residential, commercial, and industrial
                    properties. We aim to be the most trusted provider in Dubai,
                    enhancing the quality of life for our clients while
                    promoting environmental sustainability.
                  </p>
                  <div className="checklist style5 text-dark">
                    <ul className="d-flex flex-column">
                      <li className="text-dark">
                        To Be Dubai’s Most Trusted Pest Control Provider
                      </li>
                      <li className="text-dark">
                        To Lead the Industry with Innovation and Sustainability
                      </li>
                      <li className="text-dark">
                        To Set New Standards in Safety and Service Quality
                      </li>
                      <li className="text-dark">
                        To Create Healthier, Pest-Free Environments for All
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
